<template>
  <div class="leftSection">
    <div
      class="header-title wrapper-content__main font-size__large font-weight__bold"
    >
      {{title}}
    </div>
    <div class="tagFilter">
      <span
        v-for="filterOption in filterOptions"
        :key="filterOption.value"
        :class="[
          filterOption.value == filterStatus ? 'active' : '',
          'status-item'
        ]"
        @click="filterByStatus(filterOption.value)"
      >
        <i :class="['fas icon-status', filterOption.iconClass]"></i>
        <span>{{ filterOption.label }}</span>
      </span>
    </div>
  </div>
</template>

<script>

  export default {
    name: "filter-by-status-header",
    props: ["filterStatus", "filterOptions", "title"],
    data() {
      return {};
    },
    methods: {
      filterByStatus(filterStatus) {
        this.$emit("filterByStatus", {filterStatus: filterStatus});
      }
    }
  };
</script>

<style scoped>
  .leftSection {
    z-index: 10;
  }
</style>



// WEBPACK FOOTER //
// src/views/doc-out/components/filter-by-status-header.vue